/* eslint-disable */
import { takeEvery, call, put } from "redux-saga/effects";
import { GET_FORMPOST, SET_FORMPOST } from "../actions";
import {
  apiUrl, ecommerceapiUrl,
  masterheaderconfig,
  clientheaderconfig,
} from "../components/Helpers/Config";
import Axios from "axios";
export const watchGetFormPost = function* () {
  yield takeEvery(GET_FORMPOST, workerGetFormPost);
};

function* workerGetFormPost({ formPayload, postUrl, authType, method, urlType }) {
  try {
    const urlType_ = urlType ?? '';
    const result = yield call(
      getFormPost,
      formPayload,
      postUrl,
      authType,
      method,
      urlType_
    );
    var resultArr = [];
    resultArr.push(result.data);
    yield put({ type: SET_FORMPOST, value: resultArr });
  } catch(e) {
    console.log(e, postUrl + " post failed");
    let returnerror = [];
    returnerror.push(e?.response?.data||[]);
    yield put({ type: SET_FORMPOST, value: returnerror });
    
  }
}

function getFormPost(formPayload, postUrl, authType, method, urlType_) {
    var headerConfig =
      authType === "client" ? clientheaderconfig : masterheaderconfig;
      console.log(urlType_, 'urlType_urlType_urlType_urlType_')
    const apiurl_ = (urlType_==='ecom')?ecommerceapiUrl:apiUrl;
    if (method === "update") {
      return Axios.put(apiurl_ + postUrl, formPayload, headerConfig);
    } else {
      return Axios.post(apiurl_ + postUrl, formPayload, headerConfig);
    }
}
